import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { HelmetProvider } from "react-helmet-async";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Navigation from './components/Navigation';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import AboutPage from './pages/AboutPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import AGBPage from './pages/AGBPage';
import AdminPage from './pages/AdminPage';
import ProzessanalysePage from './pages/ProzessanalysePage';
import KIToolEntwicklungPage from './pages/KIToolEntwicklungPage';
import GeschaeftsideenPage from './pages/GeschaeftsideenPage';
import SystemeLandingpagesPage from './pages/SystemeLandingpagesPage';
import IndividuellePage from './pages/IndividuellePage';
import BlogPage from './pages/BlogPage';
import BlogArticlePage from './pages/BlogArticlePage';
import KathiWidget from './components/KathiWidget';

gsap.registerPlugin(ScrollTrigger);

const PublicLayout = ({ children }) => {
  const mainRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.utils.toArray('.fade-up').forEach((element) => {
        gsap.fromTo(element, 
          { y: 40, opacity: 0 },
          {
            scrollTrigger: {
              trigger: element,
              start: 'top 90%',
              toggleActions: 'play none none none',
            },
            y: 0,
            opacity: 1,
            duration: 0.8,
            ease: 'power3.out',
          }
        );
      });
      gsap.utils.toArray('.reveal-text').forEach((element) => {
        gsap.fromTo(element,
          { y: '100%', opacity: 0 },
          {
            scrollTrigger: {
              trigger: element.parentElement,
              start: 'top 85%',
              toggleActions: 'play none none none',
            },
            y: '0%',
            opacity: 1,
            duration: 0.8,
            ease: 'power3.out',
          }
        );
      });
    }, mainRef);
    return () => ctx.revert();
  }, []);

  return (
    <div ref={mainRef}>
      <Navigation />
      <main>{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) {
    return <AdminPage />;
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/produkte" element={<ProductsPage />} />
        <Route path="/ueber-uns" element={<AboutPage />} />
        <Route path="/prozessanalyse" element={<ProzessanalysePage />} />
        <Route path="/ki-tool-entwicklung" element={<KIToolEntwicklungPage />} />
        <Route path="/geschaeftsideen" element={<GeschaeftsideenPage />} />
        <Route path="/systeme-landingpages" element={<SystemeLandingpagesPage />} />
        <Route path="/individuelle-loesungen" element={<IndividuellePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogArticlePage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/agb" element={<AGBPage />} />
      </Routes>
    </PublicLayout>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App bg-[#FAFBFC] min-h-screen">
        <BrowserRouter>
          <AppContent />
          {/* KathiWidget ausgeblendet bis Voice-Feature live geht */}
          {/* <KathiWidget /> */}
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
